import React from "react";
import { BrowserRouter, Routes as RouterRoutes, Route } from "react-router-dom";
import ScrollToTop from "components/ScrollToTop";
import ErrorBoundary from "components/ErrorBoundary";
import NotFound from "pages/NotFound";
import PartnerAuthentication from './pages/partner-authentication';
import AdminPartnerManagement from './pages/admin-partner-management';
import PartnerProfile from './pages/partner-profile';
import CreateLead from './pages/create-lead';
import PartnerDashboard from './pages/partner-dashboard';
import LeadDetails from './pages/lead-details';

const Routes = () => {
  return (
    <BrowserRouter>
      <ErrorBoundary>
      <ScrollToTop />
      <RouterRoutes>
        {/* Define your route here */}
        <Route path="/" element={<PartnerAuthentication />} />
        <Route path="/partner-authentication" element={<PartnerAuthentication />} />
        <Route path="/admin-partner-management" element={<AdminPartnerManagement />} />
        <Route path="/partner-profile" element={<PartnerProfile />} />
        <Route path="/create-lead" element={<CreateLead />} />
        <Route path="/partner-dashboard" element={<PartnerDashboard />} />
        <Route path="/lead-details/:id" element={<LeadDetails />} />
        <Route path="*" element={<NotFound />} />
      </RouterRoutes>
      </ErrorBoundary>
    </BrowserRouter>
  );
};

export default Routes;